export const PRIVACY_POLICY_URL =
  'https://healthbookplus.com/wp-content/uploads/2022/09/Privacy-Policy.pdf'

export const TERMS_OF_USE =
  'https://healthbookplus.com/wp-content/uploads/2021/12/HealthBook-Terms-of-Use.pdf'
